export default __webpack_public_path__ + "static/media/uploader-img.697e818b.svg";